import WbSunnyIcon from "@mui/icons-material/WbSunny";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import WbSunnyTwoToneIcon from "@mui/icons-material/WbSunnyTwoTone";
import { Chip, Stack, Typography } from "@mui/material";

const FilterSunlight = ({ value, onChange }) => {
  const handleClick = (level) => {
    const newValue = value.includes(level)
      ? value.filter((item) => item !== level)
      : [...value, level];

    onChange(newValue);
  };

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Sunlight
      </Typography>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        <Chip
          icon={<WbSunnyIcon />}
          label="Full Sun"
          clickable
          color={value.includes("Full Sun") ? "primary" : "default"}
          onClick={() => handleClick("Full Sun")}
        />
        <Chip
          icon={<WbSunnyTwoToneIcon />}
          label="Partial Shade"
          clickable
          color={value.includes("Partial Shade") ? "primary" : "default"}
          onClick={() => handleClick("Partial Shade")}
        />
        <Chip
          icon={<WbSunnyOutlinedIcon />}
          label="Shade"
          clickable
          color={value.includes("shade") ? "primary" : "default"}
          onClick={() => handleClick("shade")}
        />
      </Stack>
    </>
  );
};

export default FilterSunlight;
